
import Vue from 'vue'
import PriceLabel from '@/components/PriceLabel.vue'
import BaseImage from '@/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/constants'
// import PrintTag from '@/components/PrintTag.vue'

export default Vue.extend({
  components: {
    PriceLabel,
    BaseImage
    // PrintTag
  },
  props: {
    alt: {
      type: String,
      required: true
    },
    itemUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
    required: true
    },
    lead: {
      type: String,
      required: false,
      default: undefined
    },
    minPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    minQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    maxQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    minCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    campaignRatio: {
      type: Number,
      required: false,
      default: 0
    },
    printTag: {
      type: String,
      default: null
    }
  },
  computed: {
    hasCampaignPrice(): boolean {
      return !!this.minCampaignPrice
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  methods: {
    quantityLabel(quantity?: number): string {
      if (!quantity || quantity == 1) return 'No minimum quantity'
      else return 'Order as few as '
    }
  }
})
